module.exports = __webpack_public_path__ + "static/productentry1-406052e5865529e9ca097179b8e24ed3.png";